import { defineStore } from "pinia";
import Axios, { AxiosError } from "axios"
import useApi from "@/api";

const { authApi } = useApi();

export interface User {
    id: string;
    name: string;
    email: string;
    avatarUrl: string | null;
    isAdmin: boolean;
    linkedAccounts: number;
}

export interface UserState {
    user: User | null;
}

export const useUserStore = defineStore("user", {
    state: (): UserState => ({
        user: null,
    }),

    actions: {
        async fetchUser(): Promise<void> {
            try {
                const userResult = await authApi.me();
                this.user = userResult;
            }
            catch(e) {
                if ((e as AxiosError).response?.status == 404)
                    this.user = null;
            }
        },

        logout(): void {
            this.user = null;
        }
    }
});